import React from 'react';
import classNames from 'classnames';
import i18n from '../../../i18n';

import { makeStyles } from '@material-ui/core/styles';
import { Text, TextTypography } from 'components/Text/Text';
import { Icon } from 'components/Icon/Icon';

export interface SmallButtonParams {
    onClick: () => void;
    text?: string;
    width?: number;
    icon?: unknown;
    color?: string;
    textColor?: string;
    hoverColor?: string;
    disabled?: boolean;
    className?: string;
}

const useStyles = makeStyles(theme => ({
    nextButton: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: (props: Partial<SmallButtonParams>) => (!props.icon ? 'center' : 'space-between'),
        padding: theme.spacing(1),
        alignItems: 'center',
        background: (props: Partial<SmallButtonParams>) => props.color || '#243143',
        width: (props: Partial<SmallButtonParams>) => props.width || '100%',
        height: theme.spacing(4),
        borderRadius: 100,
        cursor: 'pointer',
        opacity: (props: Partial<SmallButtonParams>) => (props.disabled ? 0.6 : 1),
        pointerEvents: (props: Partial<SmallButtonParams>) => (props.disabled ? 'none' : 'auto'),
        '&:hover': {
            background: (props: Partial<SmallButtonParams>) => props.hoverColor || 'rgb(86, 92, 101)',
        },
    },
    text: {
        color: (props: Partial<SmallButtonParams>) => props.textColor || '#FFFFFF',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    icon: {
        justifySelf: 'flex-end',
    },
}));

export const SmallButton = (params: SmallButtonParams) => {
    const { onClick, text, icon, color, textColor, hoverColor, width, disabled, className } = params;
    const classes = useStyles({ color, textColor, hoverColor, width, icon, disabled });
    const { t } = i18n.useTranslation();
    return (
        <div className={classNames(classes.nextButton, className)} onClick={onClick}>
            {text && (
                <Text className={classes.text} typography={TextTypography.PARA_ACCENT}>
                    {t(text)}
                </Text>
            )}
            {icon && <Icon className={classes.icon} component={icon} size={16} svgSize={16} color="#fff" />}
        </div>
    );
};
